module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_silver_ghost-2ef561aec8c5549fa727a39a788094ba.png";